$("#ls-vidToggle").click(function () {
	if($("#ls-vidDiv").hasClass('large-8')) {
		$("#ls-video").removeAttr("style");
		$(this).text('Shrink Video');
		$("#ls-video").toggleClass('xl');
		$('#ls-vidDiv').removeClass('large-8');
		$('.tab-container').addClass('large-12').css({"height":"500px", "margin-bottom":"10px"});
	} else {
		$("#ls-video").removeAttr("style");
		$(this).text('Expand Video');
		$("#ls-video").toggleClass('xl');
		$('#ls-vidDiv').addClass('large-8').css({"height":"100%"});
		$('.tab-container').removeClass('large-12').css({"height":"auto", "margin-bottom":"10px"});
	}
});

$('.liveevent-form').click(function(e) {
	email = $('#liveevent-field-email .form-field-email').val();
	if (helper.validateEmail(email)) {
		$('#liveevent-overlay').remove();
	} else {
		$('#liveevent-field-email .form-field-email').addClass("error");
		$('#liveevent-field-email label[for="liveevent-field-email"]').addClass("error");
	}
});

var liveeventPhase = $('#liveeventPhase').length;
if (liveeventPhase) {
	var startTime = moment($('#liveeventPhase').attr('data-start-date'), "ddd MMMM D YYYY H:m:s Z");
	var currentTime = moment($('#liveeventPhase').attr('data-time-now'), "ddd MMMM D YYYY H:m:s Z");
	var difference = startTime.diff(currentTime);
	var duration = moment.duration(difference);
	var interval = 1000;

    //interval
    if (promoPhaseInterval) {
        clearInterval(promoPhaseInterval);
    }
    var promoPhaseInterval = setInterval(function() {
        duration = moment.duration(duration - interval, 'milliseconds');

		// Display either Sign up form or Event
        if( duration > 0 ){
        	$("#liveevent-form").removeClass("hide");
        } else {
        	$("#liveevent-form").addClass("hide");
        	$("#liveevent-event").removeClass("hide");
        	$('#liveevent-overlay').css({"display":"block"});
        }

		// Display Countdown to Event
		var days = (duration.days() + " day" + ((duration.days() === 1) ? '' : 's'));
		var hours = (duration.hours() + " hour" + ((duration.hours() === 1) ? '' : 's'));
		var minutes = (duration.minutes() + " minute" + ((duration.minutes() === 1) ? '' : 's'));
		var seconds = (duration.seconds() + " seconds");

		$('.form-counter').text(days + " : " + hours + " : " + minutes + " : " + seconds);

	}, interval);
}

//$('.liveevent-signup-form').css({"display": "none"});
$('.liveevent-show-form').click(function() {
	$('.liveevent-lead-gate').css({"display": "none"});
	$('.liveevent-signup-form').css({"display": "block"});
});

$('.liveevent-show-gate').click(function() {
	$('.liveevent-lead-gate').css({"display": "block"});
	$('.liveevent-signup-form').css({"display": "none"});
});

$('.fa-close').click(function() {
	$('#liveevent-overlay').remove();
});


$('div[data-tab="chat"]').click(function() {
	$('div[data-panel="chat"]').show();
	$('div[data-panel="poll"]').hide();
	$('div[data-tab="poll"]').removeClass('active-tab');
	$(this).addClass('active-tab');
});

$('div[data-tab="poll"]').click(function() {
	$('div[data-panel="poll"]').show();
	$('div[data-panel="chat"]').hide();
	$('div[data-tab="chat"]').removeClass('active-tab');
	$(this).addClass('active-tab');
});




//////////////////
// WEBPACK FOOTER
// ./public/js/liveevent.js
// module id = 80
// module chunks = 0